import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ISpecialtyCategory } from "app/models/core/admin/specialtyCategory";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";


@Component({
  selector: 'app-specialtyCategory',
  templateUrl: './specialtyCategory.component.html'

})

export class SpecialtyCategoryComponent implements OnInit {

  list: ISpecialtyCategory[] = [];
  item: ISpecialtyCategory;
  displayedColumns: string[] = ['t_CD', 'specialty', 'subSpecialty', 'pt', 'action'];

  dataSource = new MatTableDataSource<ISpecialtyCategory>(this.list);

  listFilter = '';
  editMode = 'list';

  formGroup = new UntypedFormGroup({
    SpecialtyListId: new UntypedFormControl(0),
    T_CD: new UntypedFormControl('', [Validators.required]),
    MajorCat: new UntypedFormControl('', [Validators.required]),
    LicAbbrev: new UntypedFormControl('', [Validators.required]),
    PT: new UntypedFormControl('Y', [Validators.required]),
    UpdatedBy: new UntypedFormControl('')
  });

  @ViewChild('TablePaginator') paginator !: MatPaginator;
  @ViewChild('TableSort') sort!: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService
  ) { };

  ngOnInit() {
    this.editMode = 'list';
    this.loadList();
  }

  loadList() {
    this.adminService.getSpecialtyCategories().subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.timeout();
      },
      error => console.log('error: ', error),
      () => {
        this.editMode = 'list';
      }
    );
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 500);
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  edit(item: ISpecialtyCategory) {
    this.item = item;
    this.formGroup.patchValue({
      SpecialtyListId: item.specialtyListId,
      T_CD: item.t_CD,
      MajorCat: item.majorCat,
      LicAbbrev: item.licAbbrev,
      PT: item.pt,
      UpdatedBy: item.updatedBy
    });
    this.formGroup.markAsPristine();
    this.editMode = 'edit';
  }

  print() {
    //TODO
  }

  add() {
    this.clearForm();
    this.editMode = 'add';
  }

  clearForm() {
    this.formGroup.patchValue({
      SpecialtyListId: 0,
      T_CD: '',
      MajorCat: '',
      LicAbbrev: '',
      PT: '',
      UpdatedBy: ''
    }
    );
  }

  save() {
    if (this.formGroup.valid && this.formGroup.dirty) {
      let form = this.formGroup.getRawValue();

      // Checking for duplicate codes
      let duplicate = false
      if (this.editMode == 'add') {
        let newCode = form.T_CD;
        this.list.forEach(function (val) {
          if (val.t_CD == newCode) {
            console.log('Duplicate : ' + newCode);
            alert('Duplicate Specialty ID. Please edit existing record.');
            duplicate = true;
          }
        });
      }

      if (!duplicate) {
        let evaluator: ISpecialtyCategory = {
          specialtyListId: form.SpecialtyListId,
          t_CD: form.T_CD,
          majorCat: form.MajorCat,
          licAbbrev: form.LicAbbrev,
          pt: form.PT,
          updatedBy: form.UpdatedBy
        };

        this.adminService.saveSpecialtyCategory(evaluator, 'Save').subscribe(
          () => {
            this.loadList();
          },
          error => console.log('error: ', error),
          () => {
          }
        );
      }
    }
  }

  delete() {
    if (!confirm('DELETE Specialty Category? Continue?')) {
      return;
    }
    this.adminService.saveSpecialtyCategory(this.item, 'Delete').subscribe(
      () => {
        this.loadList();
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  cancel() {
    if (this.formGroup.dirty) {
      if (!confirm('Unsaved changes. Continue?')) {
        return;
      }
    }
    this.clearForm();
    this.editMode = 'list';
  }

}